export interface Testimonial {
  text: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    text: "I've been turning spanners on trucks for nineteen years and I still used to lose half a day chasing a low power complaint. What changed for me is the symptom-to-cause matrix. A Scania came in derated with no obvious codes, I followed the boost path instead of guessing, and the charge-air leak showed up in under an hour. I keep the checklists printed in the workshop now.",
    author: 'Craig Hollinshead',
    role: 'Heavy-Duty Diesel Technician, 44',
    location: 'Manchester, United Kingdom',
  },
  {
    text: "Cold weather no-starts are our bread and butter up here and everyone in the shop had a different theory about where to start. The diagnostic workflow module gave us one sequence everybody follows. Two of my apprentices used the fuel supply tests last week and found an aeration leak that I would have blamed on the pump three years ago.",
    author: 'Shane Marchand',
    role: 'Shop Foreman, Heavy Truck Fleet, 51',
    location: 'Calgary, Canada',
  },
  {
    text: "The DTC and live data guide is the part I use daily. Comparing commanded versus actual rail pressure and knowing what test comes next stopped me from throwing parts at the problem. I condemned two injectors last year that I probably didn't need to. That hasn't happened since I started working through the fuel system paths properly.",
    author: 'Dale Whitfield',
    role: 'Diesel Diagnostic Technician, 37',
    location: 'Houston, United States',
  },
  {
    text: "I work mostly on agricultural and mining gear, so DPF and SCR complaints are constant and the manufacturer literature is scattered everywhere. Having the emissions diagnostic paths in one place, with the exhaust temperature and DEF checks laid out in order, saved me hours on a regeneration fault that three people had already looked at.",
    author: 'Wayne Tregear',
    role: 'Field Service Diesel Mechanic, 48',
    location: 'Perth, Australia',
  },
  {
    text: "I'm three years into my apprenticeship and the hardest part was never the repair, it was knowing what to test first. The job sheets forced me to write down the complaint, the evidence and the verification. My supervisor noticed the difference within a month and I now get handed the intermittent electrical jobs nobody else wants.",
    author: 'Liam Fenton',
    role: 'Diesel Apprentice Technician, 24',
    location: 'Newcastle, Australia',
  },
]
